/**
 * NAVIGATION-HIGHLIGHT.JS
 *
 *
 */

/**
 * Initializes the observation of the page anchors. Upon intersection with the
 * user's viewport, it will highlight the according navigation item.
 *
 * @return {boolean} successful?
 */
export default function InitHighlightedNavigation(navigationList) {
	// Don't bother any initialization if there are no anchorlinks
	const anchorlinks = document.querySelectorAll('.anchorlink');
	if (anchorlinks.length === 0)
		return;

	// Merge observers with another script using this variable
	if (typeof window.PageAnchorObservers !== 'object')
		window.PageAnchorObservers = [];

	// Create a observer instance for each anchorlink there is
	anchorlinks.forEach((anchorlink) => {
		// Don't bother observing, if the anchor has no nav item
		const navigationItem = navigationList.querySelector(`a[href$='#${anchorlink.id}']`);
		if (navigationItem === null) return;

		/** @param entries {IntersectionObserverEntry} **/
		const callback = (entries) => {
			const currentHighlights = navigationList.querySelectorAll('.nav-item.active');

			// Remove the current highlighted navigation items...
			currentHighlights.forEach((element) => {
				element.classList.remove('active');
			});

			// ...and highlight the one in current view
			navigationItem.classList.add('active');
		};

		const options = {
			root: null,
			rootMargin: '0px',
			threshold: 1.0,
		};

		let observer = new IntersectionObserver(callback, options);
		observer.observe(anchorlink);
		window.PageAnchorObservers.push(observer);
	});

	return true;
}

function report(message) {
	console.error('Navigation: ' + message);

	return false;
}
